var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2486 7.32275C15.4515 7.32275 13.9165 7.60609 13.9165 8.73942C13.9165 9.87317 15.4419 10.1665 17.2486 10.1665C19.0457 10.1665 20.5807 9.88359 20.5807 8.74984C20.5807 7.61609 19.0557 7.32275 17.2486 7.32275Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.2487 6.24325C18.4729 6.24325 19.4537 5.262 19.4537 4.03825C19.4537 2.8145 18.4729 1.83325 17.2487 1.83325C16.025 1.83325 15.0437 2.8145 15.0437 4.03825C15.0437 5.262 16.025 6.24325 17.2487 6.24325Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24859 19.3228C5.4515 19.3228 3.9165 19.6061 3.9165 20.7394C3.9165 21.8732 5.44192 22.1665 7.24859 22.1665C9.04567 22.1665 10.5807 21.8836 10.5807 20.7498C10.5807 19.6161 9.05567 19.3228 7.24859 19.3228Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.2487 18.2433C8.47287 18.2433 9.4537 17.262 9.4537 16.0383C9.4537 14.8145 8.47287 13.8333 7.2487 13.8333C6.02495 13.8333 5.0437 14.8145 5.0437 16.0383C5.0437 17.262 6.02495 18.2433 7.2487 18.2433Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.25 15C22.25 18.87 19.12 22 15.25 22L16.3 20.25",
    stroke: "#CE2600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.25 9C2.25 5.13 5.38 2 9.25 2L8.20001 3.75",
    stroke: "#CE2600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.b899c30c6025d0441e7c34563be70818.svg";
export { ForwardRef as ReactComponent };